import React from 'react';
import {
  anyPlacementSecured,
  collectVisitProductIds,
  visibleProductNames,
} from '../../utils/visitProductSummary.js';
import type { NamedProduct } from '../../utils/visitProductSummary.js';

interface VisitProductChipsProps {
  visitProducts?: unknown;
  productPlacements?: unknown;
  fallbackProductId?: string | null;
  products: NamedProduct[];
  showSecuredBadge?: boolean;
  placementSecured?: boolean;
  max?: number;
}

export const VisitProductChips: React.FC<VisitProductChipsProps> = ({
  visitProducts,
  productPlacements,
  fallbackProductId,
  products,
  showSecuredBadge = false,
  placementSecured,
  max = 6,
}) => {
  const ids = collectVisitProductIds(
    visitProducts,
    productPlacements,
    fallbackProductId
  );
  const { names, extra } = visibleProductNames(ids, products, max);
  const secured =
    showSecuredBadge &&
    (typeof placementSecured === 'boolean'
      ? placementSecured
      : anyPlacementSecured(productPlacements));

  if (names.length === 0 && !secured) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {secured && (
        <span className="px-2 py-1 rounded-lg text-xs font-bold bg-green-100 text-green-800">
          Placement secured
        </span>
      )}
      {names.map((name) => (
        <span
          key={name}
          className="px-2 py-1 rounded-lg text-xs font-medium bg-white border border-gray-200 text-gray-800"
        >
          {name}
        </span>
      ))}
      {extra > 0 && (
        <span className="px-2 py-1 rounded-lg text-xs font-medium text-gray-500">
          +{extra}
        </span>
      )}
    </div>
  );
};
